"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const kheti_1 = require("../axios/kheti");
const common_1 = require("../constants/common");
const checkForCreditInsuranceAvailability = async (latLng, dataFor, lang = common_1.DEFAULT_LANG) => {
    try {
        return await (0, kheti_1.get)(`/common/v1/services?data_for=${encodeURIComponent(dataFor.join(','))}&lat_lng=${encodeURIComponent(latLng)}&lang=${lang}`);
    }
    catch (err) {
        return null;
    }
};
exports.default = checkForCreditInsuranceAvailability;
